import PortflioHistoryTable from './PortfolioHistoryTable.vue';
import WaitIndicator from "@/components/Common/WaitIndicator";
import LinkToTradespoon from '@/components/LinkToTradespoon.vue'
import vue from 'vue'
import axios from 'axios'
import {clearCookie, getCookie, setCookie} from '../../utils/cookies';

const GUIDE_COOKIE = 'PORTF_GUIDE_SHOWN';
export default vue.extend({
    name:'PortflioPage',
    components: {
        PortflioHistoryTable, WaitIndicator,LinkToTradespoon
    },
    props:{
      portfolio: Object,
      dayHistory: Array
    },
    async mounted(){
        
        this.$tours['YTour'].start();
        const rsp = await axios.get('/json/portfolio.json'); 
        this.config = rsp.data;    
        this.links = this.config.links;

        if (this.shouldShowGuide()) { 
            this.showGuide();
            this.setSkipGuide();
        }
        
    },
    data(){
        return {
            config: null,
            symbols: '',
            selected: null,
            assetType: null,
            steps: [],
            links: [],
            dates: [],
        }
    },
    methods:{
        handleCb(cb){
            this[cb]();    
        },
        shouldShowGuide() {
            return getCookie(GUIDE_COOKIE) !== 'true';
        },
        showGuide(){
            this.steps = this.config.tour;
            this.$refs["vtour"].start();
        },
        setSkipGuide() {
            setCookie(GUIDE_COOKIE, 'true');
        }
    
    }
});